import toast from "react-hot-toast";

export const handleCopy = (text) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success("Text Copied!")
    })
    .catch((err) => {
      console.log(err)
    });
};
